// extracted by mini-css-extract-plugin
export default {"title":"ChangeBalance_title__MRxm0","formWrapper":"ChangeBalance_formWrapper__A0HJ2"};